import "./App.css";
import Home from "./pages/home/Home";
import Routing from "./routing/Routing";

function App(){
    return (
      <div className="font-Barlow">
        <Routing/>  
        {/* <Home/> */}
      </div>
    );
  }

export default App;